import React, {useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiEventos from '../services/eventoService';
import ApiUsuarios from '../services/usuarioService';
import ApiAcademia from '../services/academiaService';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import ValorMonetario from '../components/ValorMonetario';

export default function AlunoEventos() {
    const [eventos, setEventos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [userStatus, setUserStatus] = useState(null);
    const [vinculo, setVinculo] = useState('');
    const token = localStorage.getItem('token');
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));

    const me = async() => {
      const response = await ApiUsuarios.me(token);
      setUserStatus(response.status);
    }

    const fetchEventos = async () => {
      try {
        const academia = await ApiAcademia.listarPorUserId(user.id, token);
        const response = await ApiEventos.listar(1); 
        setVinculo(academia.tipo_de_vinculacao);
        setEventos(response.data.eventos);
      } catch (error) {
        console.error('Erro ao buscar eventos:', error);
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader) {
        setTimeout(() => {
          loader.classList.add('fadeOut');
          loader.style.display = 'none';
        }, 600);
      }
    }
    me();
    fetchEventos();
    }, []);

    return(
      <section>
        <div className="container">
          {Array.isArray(eventos) && eventos.length > 0 ? (
            eventos.map((evento) => (

              <div className="col-lg-3 col-md-6 gallery-item" key={evento.id}>
                <div className="de-item wow">  
                  <img src={evento.foto} className="img-fluid " alt={evento.titulo}/>
                </div>
                <div className="post-text">
                  <center>
                    <div className="d-date">
                      Data: {format(new Date(evento.dataEvento), 'dd/MM/yyyy')}
                      &nbsp;&nbsp;
                      Valor: <ValorMonetario valor={vinculo==='Vinculação' ? evento.taxaVinculado : evento.taxaFiliado} />
                    </div>
                    {(userStatus ==='Ativo') &&
                      <Link to={`/evento-inscricao/${evento.url}`} className="btn-main opt-1">Realizar Inscrição</Link>
                    }
                    {(userStatus !=='Ativo') &&
                      <div className="d-date">
                        Inscrição Mediante pagamento de anuidade!
                      </div> 
                    }
                  </center>
                </div>
              </div>
            ))
          ) : (
              <div className="row align-items-center gh-5">
                  <div className="col-lg-6 position-relative">
                      <div className="images-deco-1">
                          <img src="./img/misc/treino.png" className="d-img-1" alt=""/>
                          <img src="./img/misc/treino2.png" className="d-img-2" alt=""/>
                          <div className="d-img-3 bg-color"></div>
                      </div>
                  </div>
                  <div className="col-lg-6">
                      <p >“Em breve novos eventos!</p>
                  </div>
              </div>
          )}
        </div>
      </section>
    );
}